import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogComposerAttachmentsImagePreview from './VeltCommentDialogComposerAttachmentsImagePreview/VeltCommentDialogComposerAttachmentsImagePreview';
import VeltCommentDialogComposerAttachmentsImageDelete from './VeltCommentDialogComposerAttachmentsImageDelete/VeltCommentDialogComposerAttachmentsImageDelete';
import VeltCommentDialogComposerAttachmentsImageLoading from './VeltCommentDialogComposerAttachmentsImageLoading/VeltCommentDialogComposerAttachmentsImageLoading';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogComposerAttachmentsImage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsImage.Preview = VeltCommentDialogComposerAttachmentsImagePreview;
VeltCommentDialogComposerAttachmentsImage.Loading = VeltCommentDialogComposerAttachmentsImageLoading;
VeltCommentDialogComposerAttachmentsImage.Delete = VeltCommentDialogComposerAttachmentsImageDelete;
export default VeltCommentDialogComposerAttachmentsImage;
